import React from "react"
import { NavButton } from "../navbutton/navbutton"
import navBarStyles from "../navbar/navbar.module.css"
import { phoneNumber, textNumber, emailAccount } from "../../utils/defaultMeta"
import styles from "./contact-panel.module.css"
export function ContactPanel({
  phone = phoneNumber,
  text = textNumber,
  email = emailAccount,
  forMobile = true,
}: {
  phone?: string
  text?: string
  email?: string
  forMobile?: boolean
}) {
  return (
    <div
      className={`${navBarStyles.contact} ${
        forMobile ? styles.contactMobile : styles.contactDesktop
      }`}
    >
      <NavButton
        className={navBarStyles.button}
        useAnchor={true}
        isSideContact={true}
        to={`tel:+${phone}`}
        label={"Click to Call"}
      ></NavButton>
      <NavButton
        className={navBarStyles.button}
        useAnchor={true}
        isSideContact={true}
        to={`sms:+${text}`}
        label={"Click to Text"}
      ></NavButton>
      <NavButton
        className={navBarStyles.button}
        useAnchor={true}
        isSideContact={true}
        to={`mailto:${email}`}
        label={"Click to Email"}
      ></NavButton>
    </div>
  )
}
